<template>
    <div id="panel-4" class="panel">
        <div class="panel-hdr bg-danger-800 bg-success-gradient">
            <h2>
                {{ __t('LIST') }} <span class="fw-300"><i>{{__t('NEWS_GROUPS')}}</i></span>
            </h2>

            <div class="panel-toolbar">
                <button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="add_group">
                    <i class="fal fa-plus"></i>
                </button>
            </div>
        </div>
        <div class="panel-container show pt-1 pb-1">
            <div class="panel-content">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="rounded">
                        <!-- nav-menu-reset will reset the font colors -->
                        <ul class="nav-menu  mb-sm-4 mb-md-0 rounded " v-if="worked_groups.length > 0">
                            <li v-for="group in worked_groups" >
                                <a href="#" class="waves-effect waves-themed " :class="{'active_filter':is_active_item(group),}">
                                    <strong class="dl-ref bg-success-500 hidden-sm-down" v-on:click.self="setActive(group)" v-if="group.state">active</strong>
                                    <strong class="dl-ref bg-danger-500" v-on:click.self="setActive(group)" v-if="!group.state">active</strong>


                                    <span class="nav-link-text color-black" v-on:click.self="setActive(group)">
                                        <div>
                                            <div class="position-relative">
                                                {{ __t(group.title) }}
                                            </div>

                                               <div>
                                                   <span class="small badge border border-primary text-primary" v-if="group.group_type.length > 0">
                                                        {{ __t('PWA_NEWS.' + group.group_type.toUpperCase()) }}
                                                    </span>
                                                </div>
                                        </div>
								    </span>

                                    <i class="fal fa-cog width-2 fs-xxl ml-4" v-on:click.stop="edit(group)"></i>

                                </a>
                            </li>
                        </ul>
                        <div class="filter-message js-filter-message m-0 text-left pl-4 py-3 fw-500"></div>
                    </div>
                </b-overlay>
            </div>
        </div>

        <group_modal></group_modal>
    </div>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';
import {mapGetters} from "vuex";
import Group_modal from "../modal/group/group_modal.vue";
const {mapFields} = createHelpers({
    getterType: 'news/getNewsStateField',
    mutationType: 'news/updateNewsStateField',
});
export default {
    name: "pwa_news_groups",
    components: {Group_modal},
    data() {
        return {
            groups: [],
            is_load: true,
            is_show_modal: false,

        }
    },
    created () {
        EventBus.$on('reload_groups',this.load_groups);
        this.load_groups();
    },
    methods : {

        add_group() {
            console.log('new_group')
            EventBus.$emit("open_pwa_group", 0);
        },

        edit(group) {
            EventBus.$emit("open_pwa_group", group.id);
        },

        is_active_item(item) {
            let is_active = false;
            this.active_filter_group.map(id => {
                if (parseInt(id) === parseInt(item.id)) {
                    is_active = true;
                }
            });
            return is_active;
        },

        setActive(item) {

            let to_send_groups = [];

            if (this.active_filter_group.length > 0) {
                this.active_filter_group.map(id => {
                    to_send_groups.push(parseInt(id))
                })
            }

            if (to_send_groups.includes(parseInt(item.id))) {
                let n_to_send = [];
                to_send_groups.map(id => {
                    if (parseInt(item.id) !== parseInt(id)) {
                        n_to_send.push(id)
                    }
                })
                to_send_groups = n_to_send;
            } else {
                to_send_groups.push(parseInt(item.id))
            }

            if (to_send_groups.length == 0) {
                to_send_groups = JSON.stringify([]);
            }

            EventBus.$emit('filter_select_change', {
                "type": "news",
                "value": to_send_groups
            });

        },

        async load_groups() {
            this.groups = [];
            this.is_load = true;

            await api.get('/internal/v1/catalog/pwa/news/groups').then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.groups = data.data;
                    this.groups.map(item => {
                        item.is_active = false;
                    })

                } else {
                    this.groups = [];
                }
            }).catch(({response}) => {
                this.is_load = false;
                this.groups = [];
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        }
    },

    computed : {
        ...mapFields([
            'all_filter',
            'filter'
        ]),

        active_filter_group: {
            get: function () {
                if (this.all_filter.hasOwnProperty('groups')) {
                    if (this.all_filter.groups == null) {
                        return [];
                    }
                    return this.all_filter.groups;
                }

                return [];
            },
            set: function (newValue) {
                //Set active categs
            }
        },

        worked_groups() {
            return this.groups;
        },
    }

}
</script>



<style scoped>

</style>
